module.exports = __webpack_public_path__ + "static/img/sierpinski_triangle.47a48fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sierpinski_triangle.png
// module id = aEff
// module chunks = 0